/** 브랜드 글리프 ✦ — 발광 점 + 회전 링(테라스타). 상시 미세 애니메이션(03 §6). */
export function BrandGlyph() {
  return (
    <span className="relative block h-[30px] w-[30px] flex-none" aria-hidden="true">
      <span
        className="absolute inset-0 m-auto h-[9px] w-[9px] rounded-full bg-star"
        style={{
          boxShadow: '0 0 16px 5px rgba(116,207,233,.65), 0 0 40px 10px rgba(116,207,233,.25)',
        }}
      />
      <span
        className="absolute inset-0 rounded-full motion-safe:animate-ring"
        style={{ border: '1px solid rgba(116,207,233,.35)' }}
      />
    </span>
  );
}
